import familiadosApiClient from '$utils/familiadosApiClient'
import { cookiesStorage } from '$utils/services/cookiesStorage'
import encryptService from '$utils/services/encryptService'
import { apiErrorService } from '$utils/services/apiErrorService'
import { userGroupService } from '$utils/services/userGroupService'
import { chatClient } from '$infrastructure/cometChat/cometChatClient'

export const loginUserPath = '/login'
export const logoutUserPath = '/logout'
export const verifyTokenPath = '/activate'

export const createSession = async (sessionData: { token: string; groups: [string]; id: string }) => {
  const encryptedToken = encryptService().encrypt(sessionData.token)
  cookiesStorage.saveCookie('token', encryptedToken)
  userGroupService.saveUserGroup(sessionData.groups)
}

interface WindowWithNativeProps extends Window {
  isNativeApp?: any
  ReactNativeWebView?: any
}

const sendLoginEventToReactNative = userId => {
  const windowsWithNativeProps: WindowWithNativeProps = window

  if (windowsWithNativeProps.ReactNativeWebView) {
    windowsWithNativeProps.ReactNativeWebView.postMessage(
      JSON.stringify({
        type: 'login',
        userId: userId,
      }),
    )
  }
}

const sendLogOutEventToReactNative = () => {
  const windowsWithNativeProps: WindowWithNativeProps = window

  if (windowsWithNativeProps.ReactNativeWebView) {
    windowsWithNativeProps.ReactNativeWebView.postMessage(
      JSON.stringify({
        type: 'logout',
      }),
    )
  }
}

export const loginUser = async loginInfo => {
  try {
    const sessionData = await familiadosApiClient.post<{
      token: string
      groups: [string]
      id: string
    }>(loginUserPath, {
      ...loginInfo,
    })

    sendLoginEventToReactNative(sessionData.id)

    createSession(sessionData)

    return sessionData
  } catch (error) {
    throw apiErrorService.handleError(error)
  }
}

const getToken = () => {
  const token = encryptService().decrypt(cookiesStorage.getCookie('token'))
  const userToken = cookiesStorage.getCookie('user_token')
  if (token && userToken) {
    return [token, userToken]
  }
  if (token && !userToken) {
    return [token]
  }
  return []
}

export const logoutUser = async () => {
  try {
    const tokens = getToken()
    if (tokens.length === 1) {
      await familiadosApiClient.post(logoutUserPath, { logoutToken: tokens[0] })
    }
    if (tokens.length === 2) {
      await familiadosApiClient.post(logoutUserPath, { logoutToken: tokens[1] })
    }

    sendLogOutEventToReactNative()

    await chatClient.logoutUser()

    cookiesStorage.deleteAllCookies()
  } catch (error) {
    throw apiErrorService.handleError(error)
  }
}

export const isAuthenticated = () => {
  return cookiesStorage.getCookie('token') !== ''
}

export const getRedirectPath = () => {
  const redirectPath = cookiesStorage.getCookie('redirect') || '/profile'
  cookiesStorage.deleteCookie('redirect')
  return redirectPath
}

export const saveRedirectPath = (path: string) => {
  cookiesStorage.saveCookie('redirect', path)
}

export const verifyToken = async (confirmationToken: string) => {
  try {
    await familiadosApiClient.post(verifyTokenPath, {
      confirmationToken,
    })
  } catch (error) {
    throw apiErrorService.handleError(error)
  }
}



// WEBPACK FOOTER //
// ./src/domain/model/session/session.manager.ts